import {
  ContextMenu,
  Hotkey,
  Hotkeys,
  HotkeysTarget,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
  Position
} from '@blueprintjs/core'
import i18next from 'i18next'
import React from 'react'
import { produce } from 'immer'
import { defer, throttle } from 'lodash'
import { CustomEditableTextContent2 } from '../leaf/customEditableText/customEditableTextContent'
import { regexFor$$, regexForMediaBlock } from '../leaf/customEditableText/TextAreaMode'
import { Key } from '../../../helper/classes'
import { globalOnDemandVars } from '../../../helper/context'
import insertTextAtCursor from 'insert-text-at-cursor'
import { updateMediaItemF } from '../../../backend/mediaItems/updateData'
import {
  copyTextToClipBoard,
  pasteTextFromClipBoard,
  showToastByMenuDirection,
  truncateDefault, undoManager
} from '../../../helper/functions'
import { hasScrollbarAlways, hotKeyClass } from '../../../helper/CSSclasses'
import { ctrlOrCmd } from '../../../helper/useEnvironment'
import { css as classname, cx } from 'emotion'
import { OverlayProps } from '../../../helper/configs'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { withTranslation } from 'react-i18next'

export let currentFocusedCellRef
export let currentFocusedCellRef2

@HotkeysTarget
class CustomEditor extends React.Component {
  state = {
    value: this.props.value,
    popoverOpen: false
  }
  inputRef = React.createRef()
  divRef = React.createRef()

  getValue () {
    // should return an object of key/value pairs to be merged back to the row
    const prevRowData = this.props.rowData
    const key = this.props.column.key
    const nextRowData = produce(prevRowData, draft => {
      draft[key] = this.state.value
    })
    return nextRowData
  }

  getInputNode () {
    // If applicable, should return back the primary html input node that is used to edit the data
    // Otherwise return null
    // If value is an input node, then this node will be focussed on when the editor opens
    return this.inputRef.current
  }

  // disableContainerStyles () {
  //   // Optional method
  //   // If set to true, the EditorContainer will not apply default styling to the editor
  // }

  updatePopoverState = throttle(() => {
    if (regexFor$$.test(this.state.value) || regexForMediaBlock.test(this.state.value)) {
      this.setState({ popoverOpen: true })
    } else {
      this.setState({ popoverOpen: false })
    }
  }, 500, { leading: true, trailing: true }
  )

  componentDidUpdate (prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      this.updatePopoverState()
    }
  }
  // -----------------------------------------------------------------------------------------------------------
  // for hotkey and menu

  _keys = [
    new Key('Undo', 'mod + z', () => {
      const originalValue = this.state.value
      defer(() => {
        if (originalValue === this.state.value) {
          this.inputRef.current.blur()
          this.divRef.current.blur()
          undoManager.undo()
        }
      })
    }, null, null, { notPreventDefault: true }),
    new Key('Redo 1', 'mod + shift + z', () => {
      const originalValue = this.state.value
      defer(() => {
        if (originalValue === this.state.value) {
          // this.divRef.current.blur()
          undoManager.redo()
        }
      })
    }, null, null, { notPreventDefault: true }),
    new Key('Redo 2', 'mod + y', () => {
      const originalValue = this.state.value
      defer(() => {
        if (originalValue === this.state.value) {
          // this.divRef.current.blur()
          undoManager.redo()
        }
      })
    }, null, null, { notPreventDefault: true })
  ]

  _insertKeys = [
    new Key(i18next.t('Insert media from Type 1'), 'alt + 1', () => {
      const waitingItems = globalOnDemandVars.waitingItemsForType1()
      if (waitingItems.length) {
        const setWaitingItems = globalOnDemandVars.set_waitingItemsForType1
        const usedItems = globalOnDemandVars.usedItemsForType1()
        const setUsedItems = globalOnDemandVars.set_usedItemsForType1

        const nextWaitingItems = Array.from(waitingItems)
        const nextUsedItems = Array.from(usedItems)

        const firstWaitingItems = nextWaitingItems.shift()

        nextUsedItems.unshift(firstWaitingItems)

        insertTextAtCursor(this.inputRef.current, `![${firstWaitingItems.type}](${firstWaitingItems.backId})`)

        setWaitingItems(nextWaitingItems)
        setUsedItems(nextUsedItems)

        updateMediaItemF(firstWaitingItems.globalId, {
          inWaitingItemsForType1: false,
          inUsedItemsForType1: true,
          type1Order: 0
        })

        showToastByMenuDirection({
          message: i18next.t('insertedFromT1', { itemName: truncateDefault(firstWaitingItems.title) }),
          intent: 'success',
          icon: 'import'
        })
      } else {
        showToastByMenuDirection({
          message: i18next.t('There is nothing to insert from Waiting Items of Type 1'),
          icon: 'issue'
        })
      }
    }, 'import')
  ]

  _menu = <Menu>
    <MenuItem onClick={() => {
      const inputRef1 = this.inputRef.current
      const selectionStart = inputRef1.selectionStart
      const selectionEnd = inputRef1.selectionEnd
      const selectedText = inputRef1.value.substring(selectionStart, selectionEnd)
      copyTextToClipBoard(selectedText || inputRef1.value.toString())
    }} text={i18next.t('Copy')} labelElement={
      <span className={hotKeyClass}>{`${ctrlOrCmd} + c`}</span>} />
    <MenuItem onClick={() => {
      pasteTextFromClipBoard(this.inputRef.current)
    }} text={i18next.t('Paste')} labelElement={
      <span className={hotKeyClass}>{`${ctrlOrCmd} + v`}</span>} />
    <React.Fragment>{this._insertKeys.map((key) => (<MenuItem {...key.returnPropObjForMenuItem()} />))}</React.Fragment>
    {
      this._keys.map((key, i) => (key === 'divider' ? (
        <MenuDivider key={i} />
      ) : (!key.isForMenu ? null : (
        <MenuItem {...key.returnPropObjForMenuItem()} />
      ))))
    }
  </Menu>

  onContextMenu = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.inputRef.current.focus()
    ContextMenu.show(this._menu, { left: e.clientX, top: e.clientY })
    this.inputRef.current.focus()
  }

  _onBlur = (e) => {
    this.setState({
      popoverOpen: false
    })

    if (ContextMenu.isOpen()) {
      this.inputRef.current.focus()
      e.preventDefault()
      e.stopPropagation()
      if (process.env.NODE_ENV !== 'production') {
        console.tron.log('TextAreaMode preventDefault')
      }
      return false
    }
  }

  _onFocus = (e) => {
    currentFocusedCellRef = this.divRef
    currentFocusedCellRef2 = this.inputRef
  }

  renderHotkeys = () => {
    return <Hotkeys>{
      this._keys.concat(this._insertKeys).map((key) => (!key.isForHotKey ? null : (
        <Hotkey {...key.returnPropObjForHotKey()} allowInInput preventDefault={!key.config.notPreventDefault} />
      )))
    }</Hotkeys>
  }

  render () {
    // return UI for the editor
    return (<div ref={this.divRef}>
      <Popover isOpen={this.state.popoverOpen}
        position={Position.TOP_LEFT} targetClassName={classname`width: 100%;`}
        {...OverlayProps}
        content={!this.state.popoverOpen ? null : (<div className={cx(hasScrollbarAlways, classname`width: 500px; height: 90px; overflow: auto; position: relative; font-size: 18px;`)}>
          <CustomEditableTextContent2 children={this.state.value} refCalc={() => {}} style={{ height: null, width: '100%', padding: '2px' }} />
        </div>)}>
        <input ref={this.inputRef}
          // onContextMenu={}
          css={css`width: 100%;`}
          onContextMenu={this.onContextMenu}
          onBlur={this._onBlur}
          style={{ height: this.props.height }}
          className={'rdg-text-editor'}
          value={this.state.value} onChange={(e) => { this.setState({ value: e.target.value }) }}

        />
      </Popover>
    </div>)
  }
}

export default CustomEditor
